import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { AppButton } from "../../../components/form";
import type { PrepExpansionEstimateResponse } from "../../../types/prep";

type Props = {
  open: boolean;
  estimate: PrepExpansionEstimateResponse | null;
  onCancel: () => void;
  onConfirm: () => void;
};

export default function PrepExpansionRunDialog({ open, estimate, onCancel, onConfirm }: Props) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{t("prep.design.expansionWarningTitle")}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" gutterBottom>
          {t("prep.design.expansionWarningBody", {
            rows: estimate?.estimatedRows?.toLocaleString() ?? "—",
          })}
        </Typography>
        {estimate?.expansionSummary && (
          <Typography variant="caption" color="text.secondary">
            {estimate.expansionSummary}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <AppButton variant="outlined" onClick={onCancel}>
          {t("common.cancel")}
        </AppButton>
        <AppButton color="warning" onClick={onConfirm}>
          {t("prep.design.runAnyway")}
        </AppButton>
      </DialogActions>
    </Dialog>
  );
}
